exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-optional-icons{padding:2rem 0}.section-optional-icons .mobile-big{font-size:25px;line-height:normal}.section-optional-icons .grid-cards{display:grid;grid-template-columns:1fr}@media screen and (min-width:1024px) and (max-width:1439px){.section-optional-icons .container{padding:32px!important}}@media screen and (min-width:1024px){.section-optional-icons{padding:4rem 0}.section-optional-icons .grid-cards{grid-template-columns:repeat(2,1fr)}.section-optional-icons .grid-cards>div:nth-child(odd){padding-right:16px}}@media screen and (min-width:1680px){.section-optional-icons .container{max-width:1550px}.section-optional-icons .grid-cards{grid-template-columns:repeat(4,1fr)}.section-optional-icons .grid-cards>div:nth-child(odd){padding-right:2.5rem}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};